import React, { useState } from 'react';
import "./dropMenu.scss"
import {
    NavLink
  } from "react-router-dom";

function DropMenu() {

    const[open, setOpen] = useState(false)


    return (
        <div>
            <div class="wrapper">
                <header id="header" class={open? "open" : "header"}>
                    <nav class="menu-navigation">
                    <div class="menu-icon-toggle" onClick={() => {setOpen(!open)}}><span></span></div>
                    <i class="menu-background top"></i>
                    <i class="menu-background middle"></i>
                    <i class="menu-background bottom"></i>
                    <ul class="menu">
                        <li><NavLink to="/skills">Skills</NavLink></li>
                        <li><NavLink to="/works">Works</NavLink></li>
                        <li><NavLink to="/about">About me</NavLink></li>
                        <li><NavLink to="/contacts">Contacts</NavLink></li>
                    </ul>
                    </nav>
                </header>
                </div>
         </div>
    );
}

export default DropMenu;